import { useI18next } from "@herob191/gatsby-plugin-react-i18next";

export default function useTranslate(object = {}, field = "") {
	const { language } = useI18next();

	// console.log(object, language);
	if (object?.es) {
		if (language) {
			return object[language] || object.es;
		}
		return object.es;
	}

	// throw new Error(`Error: invalid object`);
}
